var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRightCricled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow right circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1171",
    d: "M34.1666 17.5002C34.1666 26.7049 26.7047 34.1668 17.4999 34.1668C8.29517 34.1668 0.833252 26.7049 0.833252 17.5002C0.833252 8.29542 8.29517 0.833496 17.4999 0.833496C26.7047 0.833496 34.1666 8.29542 34.1666 17.5002Z",
    fill: "#0869FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 192 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0504 18.3839C25.5385 17.8957 25.5385 17.1043 25.0504 16.6161L20.0504 11.6161C19.5622 11.128 18.7708 11.128 18.2826 11.6161C17.7945 12.1043 17.7945 12.8957 18.2826 13.3839L21.1487 16.25L10.8332 16.25C10.1428 16.25 9.58317 16.8096 9.58317 17.5C9.58317 18.1904 10.1428 18.75 10.8332 18.75L21.1487 18.75L18.2826 21.6161C17.7945 22.1043 17.7945 22.8957 18.2826 23.3839C18.7708 23.872 19.5622 23.872 20.0504 23.3839L25.0504 18.3839Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCricled);
export default __webpack_public_path__ + "static/media/arrowRightCricled.6b7972813d6e42c08128f9b6a3d40ca1.svg";
export { ForwardRef as ReactComponent };